import { gql } from '@apollo/client'

/**
 * `me` — perfil del usuario autenticado.
 *
 * Mismo contrato que Zeus (controlweb). Si tu UI necesita campos adicionales
 * (negocios de la organización, facturación), define una query separada en el
 * feature que los consuma en lugar de extender ésta.
 */
/**
 * `promotionalImages` — imágenes promocionales del lobby (PÚBLICA, sin token).
 *
 * Contrato del gateway (módulo promotional): devuelve solo las activas,
 * ordenadas por `order` asc. Se administran desde Identidad
 * (identity-web → /configurations/lobby); el portal solo las consume.
 */
export const PROMOTIONAL_IMAGES = gql`
  query PromotionalImages {
    promotionalImages {
      id
      url
      urlMobile
      link
      order
      title
    }
  }
`

export const ME = gql`
  query Me {
    me {
      id
      username
      email
      firstName
      lastName
      sex
      birthdate
      photoPath
      phoneNumber
      phoneVerified
      addresses {
        id
        countryId
        provinceId
        city
        street1
        street2
        postalCode
      }
      roles {
        id
        name
        description
        context
        displayName
      }
      organization {
        id
        legalName
        logo
      }
    }
  }
`
